export default __webpack_public_path__ + "static/media/splash-image-1.d1cc38d8.png";